module.exports = __webpack_public_path__ + "static/media/ss15.c29cd96c.jpg";